import { create } from 'zustand';

// Define the shape of your store's state
interface StoreState {
  quantitee: number;
  setQuantitee: (newQuantity: number) => void;
}

// Create the Zustand store with the specified type
const useStoreQuantite = create<StoreState>((set) => ({
  quantitee: 5, // Initial value
  setQuantitee: (newQuantity) => set({ quantitee: newQuantity }), // Action to update the quantity
}));

export default useStoreQuantite;
